import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'how_many_nationalities_are_represented_among_workers_supervisors'

export const dataPointDefinition = {
  retracedId: 'how_many_nationalities_are_represented_among_workers_supervisors',
  name: 'How many nationalities are represented among workers and supervisors at the facility?',
  description:
    'This question relates to workers and supervisors, and includes the nationalities of local workers/supervisors, as well as all nationalities of foreign migrants.',
  meta: {
    slcpMeta: {
      key: 'fp-nat-1',
      number: 'FP-NAT-1',
      masterType: 'Question',
      versionImported: '1.7.0',
    },
  },
  fieldTypeId: 'SHORT_TEXT',
  type: 'RELATIONAL',
  options: [],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'fp-nat-1', version: '1.7.0', provider: 'slcp'}],
  sortingId: 27750,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
